import VerificationReasonDialog from "./VerificationReasonDialog";

export default VerificationReasonDialog;